import * as mutationTypes from './mutationTypes'

export default {
  [mutationTypes.IMAGETYPE_FROM_DOCUMENTTYPE_UPDATED](state, payload) {
    state.documentTypeImageTypeDict[payload.documentTypeId] = payload.imageTypes
  },
}
